import { Flex, Label, theme } from 'modules/ui';
import styled from 'styled-components';
import { mediaQuery } from 'modules/utils';
import { NavigationAndActionWarningSmall } from 'modules/ui/icons';

export const StyledSelectWithMessage = styled(Flex)`
  align-items: flex-start;
  width: 100%;

  ${mediaQuery('md')} {
    flex-direction: row;
    align-items: center;
    & > div:first-child {
      min-width: 22.5rem;
    }
  }
`;

export const StyledMessage = styled(Flex)`
  flex-direction: row;
  align-items: center;

  ${Label} {
    margin-bottom: 0;
    margin-left: 0.6rem;
  }

  ${mediaQuery('md')} {
    margin-left: 2.5rem;
  }
`;

export const StyledWarningIcon = styled(NavigationAndActionWarningSmall)`
  g {
    fill: ${theme.colors.primaryO5};
  }
`;
